module.exports = __webpack_public_path__ + "img/V-R-246-load-standup-base.b997a762.png";